(function($) {

	'use strict';

	var init = function() {
        dalleSlide()
        logosSlide()
    };

    var dalleSlide = function() {
        var dalle = new Swiper('.flex-slides__swiper', {
            updateOnWindowResize: true,
            centeredSlides: true,
            effect: 'coverflow',
            slidesPerView : 'auto',
            spaceBetween: 25,
            coverflowEffect: {
                rotate: 15,
                slideShadows: true,
            },
            breakpoints: {
                768: {
                    spaceBetween: 50,
                }
            }
        })
    }

    var logosSlide = function() {
        var logos = new Swiper('.flex-logos__swiper', {
            updateOnWindowResize: true,
            slidesPerView : '2',
            centeredSlides: true,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                992: {
                    slidesPerView : 4,
                    spaceBetween: 25,
                    centeredSlides: false,
                },
                1200: {
                    slidesPerView : 5,
                    spaceBetween: 25,
                    centeredSlides: false,
                }
            }
        })
    }

	$(document).ready(function() {
        init();
	});

})(jQuery);